import React, { useState, useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { fetchlogo } from "../ApiService/logo/logo";
import { footerServices } from "../data/data";

import {
  FiMail,
  FiPhone,
  FiMapPin,
  FiX,
  FiDribbble,
  FiLinkedin,
  FiFacebook,
  FiInstagram,
  FiTwitter,
  FiChevronDown,
  FiChevronUp,
  FiChevronLeft,
  FiChevronRight,
} from "../assets/icons/vander";
import { useTranslation } from "react-i18next";
import { CategoryContext } from "../components/CategoryContext";

import { getProductsByCategory } from "../ApiService/productcategory/productcategory";
import { getProductsBysubCategory } from "../ApiService/productsubcatagory/productsubcategory";
import { getProductsBybrand } from "../ApiService/Brand/productbrand";

import { fetchaboutus } from "../ApiService/aboutus/aboutus";
export default function Footer() {
  const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

  const footerShopping3 = [
    { name: "My Account", path: "/user-account" },

    { name: "Order History", path: "/order-history" },
    { name: "Wish List", path: "/wish-list" },
    // { name: "Newsletter", path: "/newsletter" },
    // { name: "Affiliate", path: "/affiliate" },
    { name: "Returns", path: "/returns" },
  ];
  const [logos, setlogos] = useState([]);
  const { categories, brand, subcategories, loading, error } =
    useContext(CategoryContext);
  const [aboutdata, setAboutData] = useState([]);

  // Accordion states
  const [openCategory, setOpenCategory] = useState(false);
  const [openSubcategory, setOpenSubcategory] = useState(false);
  const [openQuickLinks, setOpenQuickLinks] = useState(false);

  useEffect(() => {
    const getabout = async () => {
      try {
        const data = await fetchaboutus(); // Use API function
        setAboutData(data);
      } catch (err) {
        console.error("Failed to load logo:", err);
      }
    };

    getabout();
  }, []);

  useEffect(() => {
    const getlogo = async () => {
      try {
        const Logos = await fetchlogo(); // Use API function
        setlogos(Logos[0]);
      } catch (err) {
        console.error("Failed to load logo:", err);
      }
    };

    getlogo();
  }, []);

  const navigate = useNavigate();
  const [catproducts, setcatProducts] = useState([]);
  const handleCategoryClick = async (categoryId) => {
    try {
      const data = await getProductsByCategory(categoryId);
      setcatProducts(data);
      navigate(`/shop-grid-left-sidebar/category/${categoryId}`);
    } catch (err) {
      console.error(err);
    }
  };

  const [subcatproducts, setsubcatProducts] = useState([]);
  const handlesubCategoryClick = async (subcategoryId) => {
    try {
      const data = await getProductsBysubCategory(subcategoryId);
      setcatProducts(data); // store products locally (or pass to Shop page via context)
      navigate(`/shop-grid-left-sidebar/subcategory/${subcategoryId}`);
    } catch (err) {
      console.error(err);
    }
  };

  const [brandproduct, setbrandproduct] = useState([]);
  const handlepbrandClick = async (brandId) => {
    try {
      const data = await getProductsBybrand(brandId);
      setbrandproduct(data); // store products locally (or pass to Shop page via context)
      navigate(`/shop-grid-left-sidebar/brand/${brandId}`);
    } catch (err) {
      console.error(err);
    }
  };

  const { t } = useTranslation();
  return (
    <footer className="footer bg-dark-footer relative text-gray-200 dark:text-gray-200">
      <div className="container relative ">
        <div className="grid grid-cols-12">
          <div className="col-span-12">
            <div className="py-[40px] md:py-[60px] px-0">
              <div className="grid md:grid-cols-12 grid-cols-1 gap-6">
                <div className="lg:col-span-3 md:col-span-12">
                  <Link to="#" className="text-[22px] focus:outline-none">
  {logos?.footer_logo ? (
    <img
      className="h-[80px] w-[140px] md:h-[110px] md:w-[180px]"
      src={`${BASE_MEDIA_URL}${logos.footer_logo}`}
      alt="Footer Logo"
      onError={(e) => {
        e.target.style.display = "none"; // hide broken image
        e.target.parentNode.innerHTML = "Sportyfi";
      }}
    />
  ) : (
    <span>Sportyfi</span>
  )}
</Link>

                  <p className="text-gray-700 text-base md:text-lg mt-4">
                    {aboutdata?.about_us?.about_company ||
                      "Loading company slogan..."}
                  </p>
                  <ul className="list-none mt-4 md:mt-6 flex flex-wrap gap-2">
                    {[
                      "Facebook",
                      "Instagram",
                      "Twitter",
                      "LinkedIn",
                      "YouTube",
                      "Pinterest",
                      "Reddit",
                      "Google My Business",
                      "Quora",
                    ].map((platform, index) => {
                      // Find the link object for this platform
                      const url = aboutdata?.about_us?.social_links?.find(
                        (link) => link[platform]
                      )?.[platform];

                      // Map platform name to icon component
                      const IconComponent = {
                        Facebook: FiFacebook,
                        Instagram: FiInstagram,
                        Twitter: FiTwitter,
                        LinkedIn: FiLinkedin,
                        Dribbble: FiDribbble, // optional
                        // For platforms without icons you can leave as null or add custom icons
                      }[platform];

                      // If URL exists, render the link
                      return url ? (
                        <li className="inline" key={index}>
                          <Link
                            to={url}
                            target="_blank"
                            className="inline-flex hover:text-orange-500 dark:hover:text-orange-500 size-8 items-center justify-center align-middle rounded-full bg-green-500 text-white"
                            title={platform}
                          >
                            {IconComponent ? (
                              <IconComponent className="h-4 w-4" />
                            ) : (
                              platform
                            )}
                          </Link>
                        </li>
                      ) : null;
                    })}
                  </ul>
                </div>

                <div className="lg:col-span-6 md:col-span-12">
                  {/* Mobile Accordion View */}
                  <div className="md:hidden">
                    {/* Category Accordion */}
                    <div className=" border-slate-700">
                      <button
                        className="flex items-center w-full py-3 text-left"
                        onClick={() => setOpenCategory(!openCategory)}
                      >
                        {openQuickLinks ? (
                          <FiChevronDown className="text-xl" />
                        ) : (
                          <FiChevronRight className="text-xl" />
                        )}
                        <span className="text-gray-100 font-semibold">
                          Category
                        </span>
                      </button>
                      {openCategory && (
                        <div className="pb-3">
                          <ul className="list-none">
                            {categories.slice(0, 5).map((category, index) => (
                              <li className="mt-1" key={index}>
                                <button
                                  className="sub-menu-item pl-5 text-sm"
                                  onClick={() =>
                                    handleCategoryClick(
                                      category?.category_name_id
                                    )
                                  }
                                >
                                  {category?.category_name}
                                </button>
                              </li>
                            ))}
                            {categories.length > 5 && (
                              <li className="mt-1">
                                <Link
                                  to="/categories"
                                  className="sub-menu-item pl-5 text-sm text-green-500"
                                >
                                  View All
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>

                    {/* Subcategory Accordion */}
                    <div className=" border-slate-700">
                      <button
                        className="flex items-center w-full py-3 text-left"
                        onClick={() => setOpenSubcategory(!openSubcategory)}
                      >
                        {openQuickLinks ? (
                          <FiChevronDown className="text-xl" />
                        ) : (
                          <FiChevronRight className="text-xl" />
                        )}
                        <span className="text-gray-100 font-semibold">
                          Subcategory
                        </span>
                      </button>
                      {openSubcategory && (
                        <div className="pb-3">
                          <ul className="list-none">
                            {subcategories
                              .slice(0, 5)
                              .map((subcatagoryNames, index) => (
                                <li className="mt-1" key={index}>
                                  <button
                                    className="sub-menu-item pl-5 text-sm"
                                    onClick={() =>
                                      handlesubCategoryClick(
                                        subcatagoryNames?.sub_category_details
                                          ?.sub_category_id
                                      )
                                    }
                                  >
                                    {
                                      subcatagoryNames?.sub_category_details
                                        ?.sub_category_name
                                    }
                                  </button>
                                </li>
                              ))}
                            {subcategories.length > 5 && (
                              <li className="mt-2">
                                <Link
                                  to="/subcategories"
                                  className="sub-menu-item pl-5 text-sm text-green-500"
                                >
                                  View All
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                      )}
                    </div>

                    {/* Quick Links Accordion */}
                    <div className=" border-slate-700">
                      <button
                        className="flex  items-center w-full py-3 text-left"
                        onClick={() => setOpenQuickLinks(!openQuickLinks)}
                      >
                        {openQuickLinks ? (
                          <FiChevronDown className="text-xl" />
                        ) : (
                          <FiChevronRight className="text-xl" />
                        )}
                        <span className="text-gray-100 font-semibold">
                          Quick Links
                        </span>
                      </button>
                      {openQuickLinks && (
                        <div className="pb-3">
                          <ul className="list-none">
                            {footerShopping3.map((item, index) => (
                              <li className="mt-1 ml-4" key={index}>
                                <Link
                                  to={item.path}
                                  className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out text-sm"
                                >
                                  {/* <i className="mdi mdi-chevron-right"></i>  */}
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Desktop Grid View */}
                  <div className="hidden md:block">
                    <div className="grid md:grid-cols-12 grid-cols-1 gap-4 md:gap-6">
                      <div className="md:col-span-4">
                        <ul className="list-none footer-list mt-4 md:mt-6">
                          <li className="megamenu-head ms-0 text-base md:text-lg">
                            Category
                          </li>
                          {categories.slice(0, 5).map((category, index) => {
                            return (
                              <li className="ms-0 mt-[10px]" key={index}>
                                <button
                                  className="sub-menu-item pl-5 text-sm md:text-base"
                                  onClick={() =>
                                    handleCategoryClick(
                                      category?.category_name_id
                                    )
                                  }
                                >
                                  {category?.category_name}
                                </button>
                              </li>
                            );
                          })}
                          {categories.length > 5 && (
                            <li className="ms-0 mt-[10px]">
                              <Link
                                to="/categories"
                                className="sub-menu-item pl-5 text-sm md:text-base text-green-500"
                              >
                                View All
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>

                      <div className="md:col-span-4">
                        <ul className="list-none footer-list mt-4 md:mt-6">
                          <li className="megamenu-head ms-0 text-base md:text-lg">
                            Subcategory
                          </li>
                          {subcategories
                            .slice(0, 5)
                            .map((subcatagoryNames, index) => {
                              return (
                                <li className="ms-0 mt-[10px]" key={index}>
                                  <button
                                    className="sub-menu-item pl-5 text-sm md:text-base"
                                    onClick={() =>
                                      handlesubCategoryClick(
                                        subcatagoryNames?.sub_category_details
                                          ?.sub_category_id
                                      )
                                    }
                                  >
                                    {
                                      subcatagoryNames?.sub_category_details
                                        ?.sub_category_name
                                    }
                                  </button>
                                </li>
                              );
                            })}
                          {subcategories.length > 5 && (
                            <li className="ms-0 mt-[10px]">
                              <Link
                                to="/subcategories"
                                className="sub-menu-item pl-5 text-sm md:text-base text-green-500"
                              >
                                View All
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>

                      <div className="md:col-span-4">
                        <ul className="list-none footer-list mt-4 md:mt-6">
                          <li className="megamenu-head ms-0 text-base md:text-lg">
                            Quick Links
                          </li>
                          {footerShopping3.map((item, index) => (
                            <li className="mt-[10px] ms-0" key={index}>
                              <Link
                                to={item.path}
                                className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out text-sm md:text-base"
                              >
                                <i className="mdi mdi-chevron-right"></i>{" "}
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="lg:col-span-3 md:col-span-4">
                  <h5 className="tracking-[1px] text-gray-100 font-semibold text-base md:text-lg">
                    Newsletter
                  </h5>
                  <p className="mt-4 md:mt-6 text-sm md:text-base">
                    Sign up and receive the latest tips via email.
                  </p>
                  <form className="mt-4">
                    <div className="grid grid-cols-1">
                      <div className="my-3">
                        <label className="form-label text-sm md:text-base">
                          Write your email{" "}
                          <span className="text-red-600">*</span>
                        </label>
                        <div className="form-icon relative mt-2">
                          <FiMail className="size-4 absolute top-3 start-4"></FiMail>
                          <input
                            type="email"
                            className="ps-12 rounded w-full py-2 px-3 h-10 bg-gray-800 border-0 text-gray-100 focus:shadow-none focus:ring-0 placeholder:text-gray-200 outline-none text-sm"
                            placeholder="Email"
                            name="email"
                            required=""
                          />
                        </div>
                      </div>

                      <button
                        disabled
                        className="py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center bg-green-500 text-white rounded-md opacity-50 cursor-not-allowed w-full md:w-auto"
                      >
                        Subscribe
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1">
          <div className="py-[20px] md:py-[30px] px-0 border-t border-slate-800">
            {/* Mobile View: Table format with 2 items per row */}
            <div className="md:hidden">
              <table className="w-full border-collapse">
                <tbody>
                  {/* Row 1 */}
                  <tr>
                    {footerServices.slice(0, 2).map((item, index) => (
                      <td key={index} className="p-2 align-middle">
                        <div className="flex items-center ">
                          <i
                            className={`align-middle text-lg mb-0 me-2 ${item.icon}`}
                          ></i>
                          <h6 className="mb-0 font-medium text-sm">
                            {item.name}
                          </h6>
                        </div>
                      </td>
                    ))}
                  </tr>
                  {/* Row 2 */}
                  <tr>
                    {footerServices.slice(2, 4).map((item, index) => (
                      <td key={index + 2} className="p-2 align-middle">
                        <div className="flex items-center justify-center">
                          <i
                            className={`align-middle text-lg mb-0 me-2 ${item.icon}`}
                          ></i>
                          <h6 className="mb-0 font-medium text-sm">
                            {item.name}
                          </h6>
                        </div>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Desktop View: 4 items per row, centered */}
            <div className="hidden md:grid md:grid-cols-4 md:gap-4">
              {footerServices.slice(0, 4).map((item, index) => {
                return (
                  <div className="flex items-center justify-center" key={index}>
                    <i
                      className={`align-middle text-lg mb-0 me-2 ${item.icon}`}
                    ></i>
                    <h6 className="mb-0 font-medium text-sm md:text-base">
                      {item.name}
                    </h6>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="py-[20px] md:py-[30px] px-4 border-t border-slate-800">
        <div className="container relative text-center">
          <div className="grid md:grid-cols-2 items-center">
            <div className="md:text-start text-center">
              <p className="mb-0 text-sm md:text-base">
                © {new Date().getFullYear()} Sportify. Design & Develop with{" "}
                <i className="mdi mdi-heart text-red-600"></i> by{" "}
                <Link
                  to="https://www.vichaarlab.com/"
                  target="_blank"
                  className="text-reset"
                >
                  Vichaarlab
                </Link>
                .
              </p>
            </div>

            {/* <ul className="list-none md:text-end text-center mt-6 md:mt-0">
                            {paymentCart.map((item,index) =>{
                                return(
                                    <li className="inline" key={index}><Link to=""><img src={item} className="max-h-6 rounded inline" title="American Express" alt=""/></Link></li>
                                )
                            })}
                        </ul> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
